import { render, staticRenderFns } from "./TableBlueLabelDate.vue?vue&type=template&id=2b3c290b&scoped=true&"
import script from "./TableBlueLabelDate.vue?vue&type=script&lang=js&"
export * from "./TableBlueLabelDate.vue?vue&type=script&lang=js&"
import style0 from "./TableBlueLabelDate.vue?vue&type=style&index=0&id=2b3c290b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3c290b",
  null
  
)

export default component.exports